import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ITCIApplicationDeployRequest, ITCIApplicationDeployResponse } from "@tci/common";
import { NgAppDeployService } from "../ng-app-deploy.service";
import * as lodash from "lodash";

@Component({
    selector: "ng-deploy-confirm-is-alive",
    templateUrl: "./dialog-confirmation-isAlive.component.html",
    styleUrls: ["./dialog-confirmation-isAlive.component.css"]
})
export class NgDeployConfirmationDialogIsAliveComponent implements OnInit {
    @Output() close: EventEmitter<any> = new EventEmitter();
    @Input() input: ITCIApplicationDeployRequest;

    private res: ITCIApplicationDeployResponse;

    constructor(private appDeplSvc: NgAppDeployService) {
    }

    ngOnInit() {
        this.res = lodash.assign(
            this.input,
            { success: true, notificationType: null, appId: this.input.appId }
        );
    }

    confirm() {
        this.appDeplSvc.setDialogResponse(this.res);
        this.close.emit();
    }

    cancel() {
        this.res.success = false;
        this.appDeplSvc.setDialogResponse(this.res);
        this.close.emit();
    }
}
